import api from './axiosApi'

export interface MfpRead {
  id: string
  name: string
}

export interface PlanMfpRead {
  id: string
  mfp_id: string
  mfp_name: string
  assigned_at: string
  assigned_by: string
}

interface PaginationMeta {
  skip: number
  limit: number
  total: number
  has_more: boolean
}

export interface PaginatedMfpResponse {
  data: MfpRead[]
  pagination: PaginationMeta
}

export interface MfpSyncRequest {
  mfp_ids: string[]
}

const MFP_PAGE_SIZE = 20

/**
 * Fetch available MFPs (for dropdown options, supports pagination)
 */
export async function fetchMfps(params: {
  search?: string
  skip?: number
  limit?: number
}): Promise<PaginatedMfpResponse> {
  const response = await api.get<PaginatedMfpResponse>('/mfps', {
    params: {
      search: params.search || undefined,
      skip: params.skip ?? 0,
      limit: params.limit ?? MFP_PAGE_SIZE,
    },
  })
  return response.data
}

/**
 * Fetch MFPs associated with a plan
 */
export async function fetchPlanMfps(planId: string): Promise<PlanMfpRead[]> {
  const response = await api.get<PlanMfpRead[]>(`/plans/${planId}/mfps`)
  return response.data
}

/**
 * Sync (replace) MFP associations for a plan
 */
export async function syncPlanMfps(
  planId: string,
  body: MfpSyncRequest
): Promise<PlanMfpRead[]> {
  const response = await api.put<PlanMfpRead[]>(`/plans/${planId}/mfps`, body)
  return response.data
}
